<template>
    <router-link :to="currentLink + '?product_id=' + data.id" class="bg-white group rounded-md shadow-md p-4 hover:bg-blue/5 transition-all ease-in-out duration-500 block">
        <div class="flex flex-col lg:flex-row gap-4 lg:items-center">
            <div class="text-white w-[50px] h-[50px] rounded-md flex items-center justify-center flex-shrink-0">
                <img :alt="$translate(data.name)" class="w-[40px] h-[40px] object-contain" :src="data.image.replace('.png', '-gradient.png')" />
            </div>
            <div>
                <strong>
                    {{ $translate(data.name) }}
                </strong>
                <br />
            </div>
        </div>

        <hr class="border-t border-gray-300 my-4 group-hover:border-white transition-all ease-in-out duration-500" />

        <div class="flex justify-between items-center mt-2">
            <div class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center">
                <span class="hidden lg:block text-xs">
                    {{ $t('all_analysis', { name: $translate(data.name) }) }}
                </span>
                <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['data'],
    computed: {
        currentLink() {
            return '/dashboard/contentstreams';
        }
    }
};
</script>
